var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTgt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 233.7 70.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.57,6.43c-15.9,0-28.8,12.84-28.8,28.69,0,6.84,2.41,13.12,6.42,18.05l-6.42,10.63,11.7-5.61c4.78,3.52,10.7,5.61,17.1,5.61,15.9,0,28.8-12.84,28.8-28.69s-12.89-28.69-28.8-28.69M198.45,44.21c-5.04,2.13-10.87-.21-13.01-5.23-2.14-5.02.21-10.82,5.26-12.95,5.04-2.13,10.87.21,13.01,5.23,2.14,5.02-.21,10.82-5.26,12.95"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.75,63.78c-3.22,0-5.92-1.03-8.12-3.08-2.2-2.05-3.3-4.72-3.3-8.01s1.1-5.98,3.3-8.01c2.2-2.03,4.91-3.04,8.12-3.04,3.9,0,6.86,1.59,8.88,4.77l-3.8,2.05c-.51-.81-1.22-1.48-2.11-2-.89-.52-1.88-.79-2.98-.79-1.95,0-3.56.66-4.83,1.99-1.27,1.32-1.9,3-1.9,5.03s.63,3.71,1.9,5.03c1.27,1.32,2.87,1.99,4.83,1.99.9,0,1.77-.16,2.61-.48.84-.32,1.49-.7,1.96-1.15v-2.56h-5.66v-3.97h10.23v8.2c-2.42,2.69-5.47,4.04-9.14,4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.69,63.75c-3.24,0-5.91-1.04-8.03-3.12-2.11-2.08-3.17-4.73-3.17-7.93s1.06-5.85,3.17-7.93c2.11-2.08,4.79-3.12,8.03-3.12s5.95,1.04,8.06,3.11c2.11,2.07,3.17,4.72,3.17,7.95s-1.06,5.88-3.17,7.95c-2.11,2.07-4.8,3.11-8.06,3.11ZM39.98,57.73c1.19,1.32,2.76,1.99,4.71,1.99s3.53-.66,4.73-1.99c1.2-1.32,1.8-3,1.8-5.03s-.6-3.71-1.8-5.03c-1.2-1.32-2.78-1.99-4.73-1.99s-3.52.66-4.71,1.99c-1.19,1.32-1.79,3-1.79,5.03s.6,3.71,1.79,5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.23,63.37h-5.73l-8.3-21.37h5.21l5.95,16.44,5.92-16.44h5.21l-8.27,21.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.05,63.37h-4.6v-17.37h-6.27v-4.01h17.11v4.01h-6.24v17.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.4,63.37h-15.18v-21.37h15.18v4.01h-10.62v4.52h10.39v4.01h-10.39v4.84h10.62v4.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.36,63.75c-3.26,0-5.98-1.03-8.16-3.09-2.18-2.06-3.27-4.72-3.27-7.96s1.09-5.9,3.27-7.96c2.18-2.06,4.89-3.09,8.16-3.09,4.01,0,7,1.74,8.98,5.22l-3.92,1.92c-.47-.9-1.16-1.64-2.07-2.23-.91-.59-1.9-.88-2.98-.88-1.95,0-3.56.66-4.83,1.99-1.27,1.32-1.9,3-1.9,5.03s.63,3.71,1.9,5.03c1.27,1.32,2.87,1.99,4.83,1.99,1.07,0,2.06-.29,2.98-.87.91-.58,1.6-1.32,2.07-2.24l3.92,1.89c-2.04,3.5-5.03,5.26-8.98,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.37,63.37h-4.6v-8.97h-10.13v8.97h-4.57v-21.37h4.57v8.4h10.13v-8.4h4.6v21.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.79,32.85h-1.87V13.15h-7.01v-1.67h15.89v1.67h-7.01v19.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.05,32.85h-2.12l-2.12-5.26h-11.36l-2.12,5.26h-2.12l8.78-21.37h2.28l8.78,21.37ZM121.19,25.93l-5.08-12.5-5.05,12.5h10.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.42,32.85h-12.22V11.48h1.83v19.71h10.39v1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.82,32.85h-2.35l-8.85-10.06-2.38,2.6v7.47h-1.83V11.48h1.83v11.7l10.36-11.7h2.35l-9.14,10.19,10,11.18Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTgt);
export default __webpack_public_path__ + "static/media/White TGT.ac40cf860eb46d7b59a661d224bf5a79.svg";
export { ForwardRef as ReactComponent };